import { gql } from '@apollo/client'

export const FIELD_FRAGMENT = gql`
  fragment FIELD on Field {
    active
    entityId
    fieldType
    format {
      active
      id
      label
      value
    }
    id
    label
    multiline
    multiple
    name
    restricted
    objectEntityId
    objectSecurityId
    options {
      active
      id
      label
      value
    }
    parentFieldId
    position
    readonly
    required
    settings
    source
    standard
    wysiwyg
    historyEnabled
    backgroundColor
    hidden
    limitResponse
    displayEmail
    responseType
    responseTypeId
    weight
    hideName
    includeHistoryInApiResponse
    hideOnPublic
    isPublicOnly
    showUserDetails
    visibleUserDetailsFields
    searchable
    searchTemplateIds
    exportHeaders
    aiContextDescription
    includeInAiContext
    aiAutoPopulate
    aiIncludeHistory
    aiSuggestedPrompts
  }
`

export const FIELD_LOGS_QUERY = gql`
  query FIELD_LOGS($filter: LogFilterInput, $pagination: PaginationInput) {
    logs(filter: $filter, pagination: $pagination) {
      data {
        id
        createdAt
        entityId
        user {
          id
          firstName
          lastName
          avatarUrl
        }
        metadata {
          value
        }
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`
